// extracted by mini-css-extract-plugin
module.exports = {"header-global":"NavigationHeader_header-global__04BEe"};